import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { withErrorBoundary } from "app/ErrorBoundary/ErrorBoundaryDashboard";
import { HeadedContainer } from "features/CenterContent/VehicleDetails/shared/HeadedContainer";
import {
  SharedGridPadding,
  SharedGridStyleNoPadding,
} from "features/CenterContent/shared/MainContentGrid";
import TilsynAlerts from "features/CenterContent/shared/TilsynAlerts/TilsynAlerts";
import {
  VehicleAlertResponse,
  VehicleAlertResponseSchema,
} from "features/CenterContent/shared/TilsynAlerts/schema";
import { Text } from "shared/components/Spor";
import { FailureMessage } from "shared/components/feedback/FailureMessage/FailureMessage";

const TilsynContent = () => {
  const { data, isPending, isError, isSuccess } = useQuery({
    queryKey: ["getImportantActiveVehicleAlerts"],
    refetchInterval: 60000,
    queryFn: ({ signal }) =>
      axiosClient
        .get<VehicleAlertResponse>(
          `${getBackendUrl()}/vehicle-alerts?onlyImportant=true`,
          {
            signal,
          },
        )
        .then((res) => VehicleAlertResponseSchema.parse(res.data)),
  });

  if (isError) {
    return <FailureMessage />;
  }

  return (
    <TilsynAlerts
      alerts={data?.alerts}
      isLoading={isPending}
      isSuccess={isSuccess}
      fullSize
    />
  );
};

const Tilsyn = () => (
  <HeadedContainer
    panelStyle={SharedGridStyleNoPadding}
    headerHeight="54px"
    variant="main"
    header={
      <Text variant="sm" fontWeight={600} mr="auto" p={SharedGridPadding}>
        Alarmer i Tilsyn
      </Text>
    }
  >
    <TilsynContent />
  </HeadedContainer>
);

export default withErrorBoundary(Tilsyn);
